module.exports = __webpack_public_path__ + "static/media/image_post.871ebdaf.svg";